import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostSignupLandingComponent } from './post-signup-landing.component';

const routes: Routes = [
    {
        path: '',
        component: PostSignupLandingComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PostSignupLandingRoutingModule { }